import { render, staticRenderFns } from "./ProjectMarginsPage.vue?vue&type=template&id=4c5005f8&scoped=true"
import script from "./ProjectMarginsPage.vue?vue&type=script&lang=ts"
export * from "./ProjectMarginsPage.vue?vue&type=script&lang=ts"
import style0 from "./ProjectMarginsPage.vue?vue&type=style&index=0&id=4c5005f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5005f8",
  null
  
)

export default component.exports